import './index.sass';
import Swiper from 'swiper/swiper-bundle.min';
import 'swiper/swiper-bundle.min.css';

export default () => {
    $('body').on('click', '.js-show-answers', function(e) {
        if (e.target.className === 'premium-page__question-button') {
            if ($(this).find('.premium-page__answers').css('display') === 'block') {
                $(this).find('.premium-page__question-button').css("transform", "rotate(90deg)")
                $(this).find('.premium-page__answers').fadeOut(400);
            } else {
                $(this).find('.premium-page__question-button').css("transform", "rotate(45deg)")
                $(this).find('.premium-page__answers').fadeIn(200);
            }
        }
    })

    $('body').on('click', '.premium-page__payment', function() {
        $('.account-modal').fadeIn(300);
        $('.account-window').fadeIn(300);
        $('body').css('overflow', 'hidden');
        return false;
    });

    $('body').on('click', '.account-modal', function() {
        $('.account-modal').fadeOut(300);
        $('body').css('overflow', 'auto');
        setTimeout(function() {
            return $('.account-window').hide();
        }, 300);
        return false;
    });

    $('body').on('click', '.account-window', function(e) {
        e.stopPropagation();
        return true;
    });

    $('body').on('click', '.payment-type', function() {
        let subscriptionType;
        if (!$(this).hasClass('current')) {
            subscriptionType = $(this).data('subscription-type');
            $(this).closest('form').find('#subscription_type').val(subscriptionType);
            $('.payment-type.current').removeClass('current');
            $(this).addClass('current');
        }
        return false;
    });

    $('body').on('click', '.payment-block__buttons', function() {
        let paymentService;
        if (!$(this).hasClass('current')) {
            paymentService = $(this).data('payment-service');
            $(this).closest('form').find('#payment_service').val(paymentService);
            $('.payment-block__buttons.current').removeClass('current');
            $(this).addClass('current');
        }
        return false;
    });
    $('.account-modal__button').click(function () {
        $(this).closest('form').submit();
    });

    const $root = $('.js-premium-page-slider');

    const swiper = new Swiper('.js-premium-page-slider', {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
            992: {
                spaceBetween: 41
            },
        },
        navigation: {
            nextEl: $root.parent().find('[data-role="next"]').get(0),
            prevEl: $root.parent().find('[data-role="prev"]').get(0),
        },
    });
    if (window.screen.availWidth > 991) {
        swiper.on('slideChange', function() {
            if (swiper.realIndex > swiper.slides.length - 4) {
                $root.parent().find('[data-role="next"]').get(0).classList.add('swiper-button-disabled');
                swiper.allowSlideNext = false;
            } else {
                $root.parent().find('[data-role="next"]').get(0).classList.remove('swiper-button-disabled');
                swiper.allowSlideNext = true;
            }
        })

        swiper.on('slideChangeTransitionEnd', function() {
            if (swiper.realIndex > swiper.slides.length - 4) {
                swiper.slideTo(swiper.slides.length - 3, 300)
            }
        })
    }
    const scrollButton = document.querySelector('.banner__main-button')
    if (scrollButton)  {
        scrollButton.addEventListener('click', function(e) {
            e.preventDefault();

            let href = this.getAttribute('href').substring(1);

            const scrollTarget = document.getElementById(href);
            let topOffset;
            window.screen.availWidth > 991 ? topOffset = 50 : topOffset = 70;
            const elementPosition = scrollTarget.getBoundingClientRect().top;
            const offsetPosition = elementPosition - topOffset;

            window.scrollBy({
                top: offsetPosition,
                behavior: 'smooth'
                });
        });
    }
};
